import _axios from "../axios.config";
import { END_POINTS } from "./endPoints";
import { toast } from "react-toastify";

export const getAllSaveplaces = async (data, onSuccess) => {
  try {
    let response = await _axios.get(END_POINTS.GET_ALL_SAVED_PLACES, data);
    if (onSuccess) onSuccess(response?.data);
    console.log("response in all saved places", response);
    return response?.data?.data;
  } catch (e) {
    console.log("error in saved places", e);
    // let errorMessage =
    //   e?.response?.data?.errors[0]?.message ||
    //   e?.response?.data?.message ||
    //   "Something went wrong";
    // toast.error(errorMessage);
  }
};

export const saveItemAPI=async(type,itemId)=>{

  try{
 let response=await _axios.post(`api/saved-items/${type}/${itemId}`,{});
 return response?.data?.data;

  }
  catch(e){
    console.error("Cannot add place ",e?.message);
  }

}
